interface LoadingScreenProps {
  message?: string;
}

export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 dark:bg-avemio-dark-bg">
      <div className="mb-4">
        <img src="/avemio-logo.png" alt="Avemio Logo" className="h-24 animate-pulse" />
      </div>
      <p className="mt-4 text-lg text-gray-600 dark:text-avemio-dark-text-secondary">{message}</p>
    </div>
  );
}

